import { createFileRoute, Link, useNavigate } from '@tanstack/react-router'
import { AuthForm } from '@/components/auth-form'
import { AccountHeader } from '@/components/account-nav'
import { getBillingStatus, postSignup } from '@/lib/kwykedit-api'

export const Route = createFileRoute('/routes/signup')({
  component: SignupPage,
})

function SignupPage() {
  const navigate = useNavigate()

  const handleSignup = async (email: string, password: string) => {
    await postSignup(email, password)
    // New accounts start without access → send them to pricing; paid/comped
    // accounts (or an unreachable billing check) go straight to projects.
    const hasAccess = await getBillingStatus()
      .then((s) => s.has_access)
      .catch(() => true)
    await navigate({ to: hasAccess ? '/projects' : '/pricing' })
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <AccountHeader />
      <div className="mx-auto max-w-md px-6 py-12">
        <h1 className="mb-2 text-2xl font-bold">Create your account</h1>
        <p className="mb-6 text-sm text-muted-foreground">
          Sign up, then grab the $3/mo plan to unlock the editor.
        </p>
        <div className="rounded-xl border border-border bg-card p-6">
          <AuthForm
            submitLabel="Sign up"
            onSubmit={handleSignup}
            switchPrompt="Already have an account?"
            switchTo="/login"
            switchLabel="Log in"
          />
        </div>
        <p className="mt-4 text-center text-xs text-muted-foreground">
          <Link to="/" className="underline hover:opacity-80">
            ← Back to home
          </Link>
        </p>
      </div>
    </div>
  )
}
